// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-gallery-container[data-v-7a4a8fbf]{padding:4rem;height:420px;background-color:var(--light-color)}.image-gallery-container .v-window[data-v-7a4a8fbf]{height:100%!important}.image-gallery-container .v-window .v-row[data-v-7a4a8fbf]{gap:1.5rem}.image-gallery-container .v-window .v-row .v-col[data-v-7a4a8fbf]{color:var(--medium-color);cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
